import { useContext } from "react";
import { UniversalEntityPageContext } from "../../UniversalEntityPage/contexts/UniversalEntityPageContext";

export function useViewMode() {
  let viewMode: "table" | "grouped" | "cards" | "board" = "table";
  let setViewMode: (mode: "table" | "grouped" | "cards" | "board") => void = () => {};

  try {
    // Use useContext directly to avoid the error-throwing hook
    const context = useContext(UniversalEntityPageContext);
    if (context && context.viewModeState) {
      viewMode = context.viewModeState.viewMode;
      setViewMode = context.viewModeState.setViewMode;
    }
  } catch (error) {
    // Context not available - this is expected in some cases
    if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
      console.debug("useViewMode: Context not available, using defaults");
    }
  }

  return { viewMode, setViewMode };
}
